<template>
    <el-dialog 
        title="Duyệt level nhân sự" 
        :visible.sync="visible" 
        width="500px" 
        :before-close="handleClose"
        :close-on-click-modal="false">
        
        <div>
            <validation-observer ref="observer" v-slot="{ invalid }">
                <form @submit.prevent="handleConfirm">
                    <div class="filter-section">
                        <div class="filter-row">
                            <div class="filter-item">
                                <span class="filter-label">Lọc năm <span class="text-danger">*</span></span>
                                <validation-provider rules="required" v-slot="{ errors }">
                                    <el-select 
                                        v-model="selectedYear" 
                                        :class="{'is-invalid': errors.length > 0}"
                                        style="width: 100%;" 
                                        clearable 
                                        placeholder="Chọn năm"
                                        @change="onYearChange">
                                        <el-option 
                                            v-for="item in yearOptions" 
                                            :key="item.value" 
                                            :label="item.label" 
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-if="errors.length > 0" class="invalid-feedback d-block">
                                        Năm là bắt buộc
                                    </span>
                                </validation-provider>
                            </div>
                            
                            <div class="filter-item">
                                <span class="filter-label">Lọc quý <span class="text-danger">*</span></span>
                                <validation-provider rules="required" v-slot="{ errors }">
                                    <el-select 
                                        v-model="selectedQuarter" 
                                        :class="{'is-invalid': errors.length > 0}"
                                        style="width: 100%;" 
                                        clearable 
                                        placeholder="Chọn quý"
                                        @change="onQuarterChange">
                                        <el-option 
                                            v-for="item in quarterOptions" 
                                            :key="item.value" 
                                            :label="item.label" 
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-if="errors.length > 0" class="invalid-feedback d-block">
                                        Quý là bắt buộc
                                    </span>
                                </validation-provider>
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary font-weight-bold mr-2" @click="handleClose">
                            Hủy
                        </button>
                        <button 
                            type="submit"
                            class="btn btn-purple font-weight-bold mr-2" 
                            :disabled="invalid || isLoading">
                            <i v-if="isLoading" class="fas fa-spinner fa-spin mr-1"></i>
                            <i v-else class="fas fa-check"></i> Xác nhận
                        </button>
                    </div>
                </form>
            </validation-observer>
        </div>
    </el-dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    name: 'ApproveLevelModal',
    components: {
        ValidationProvider,
        ValidationObserver
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedYear: null,
            selectedQuarter: null,
            isLoading: false,
            yearOptions: [],
            quarterOptions: [
                { value: 1, label: 'Quý 1' },
                { value: 2, label: 'Quý 2' },
                { value: 3, label: 'Quý 3' },
                { value: 4, label: 'Quý 4' }
            ]
        }
    },
    computed: {
        isFormValid() {
            return this.selectedYear !== null && this.selectedQuarter !== null;
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.initializeDefaultValues();
            }
        }
    },
    mounted() {
        this.initializeYearOptions();
    },
    methods: {
        initializeYearOptions() {
            const currentYear = new Date().getFullYear();
            this.yearOptions = [];
            for (let i = currentYear - 5; i <= currentYear + 1; i++) {
                this.yearOptions.push({ value: i, label: i.toString() });
            }
        },
        initializeDefaultValues() {
            const currentDate = new Date();
            this.selectedYear = currentDate.getFullYear();
            this.selectedQuarter = Math.ceil((currentDate.getMonth() + 1) / 3);
        },
        onYearChange(value) {
            this.selectedYear = value;
        },
        onQuarterChange(value) {
            this.selectedQuarter = value;
        },
        handleClose() {
            this.resetLoadingState();
            this.clearValidation();
            this.$emit('close');
        },
        resetLoadingState() {
            this.isLoading = false;
        },
        clearValidation() {
            if (this.$refs.observer) {
                this.$refs.observer.reset();
            }
        },
        async handleConfirm() {
            // Validate form trước khi submit
            const isValid = await this.$refs.observer.validate();
            console.log('isValid', isValid);
            
            if (!isValid) {
                this.$message({
                    type: 'error',
                    message: 'Vui lòng điền đầy đủ thông tin bắt buộc!'
                });
                return;
            }
            
            if (this.isFormValid && !this.isLoading) {
                this.isLoading = true;
                
                try {
                    const data = {
                        year: this.selectedYear,
                        quarter: this.selectedQuarter
                    };
                    
                    await this.$emit('confirm', data);
                    
                } catch (error) {
                    console.error('Error during approval:', error);
                    this.$message({
                        type: 'error',
                        message: 'Có lỗi xảy ra khi duyệt level. Vui lòng thử lại!'
                    });
                }
            }
        }
    }
}
</script>

<style scoped>
.btn-purple {
  background-color: #6f42c1;
  border-color: #6f42c1;
  color: #fff;
  font-weight: 500;
}

.filter-section {
    margin-bottom: 30px;
}

.filter-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.filter-item {
    display: flex;
    flex-direction: column;
}

.filter-label {
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
}

/* Validation styles */
.is-invalid {
    border-color: #dc3545 !important;
}

.invalid-feedback {
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
}

.text-danger {
    color: #dc3545 !important;
}

/* Responsive */
@media (max-width: 576px) {
    .filter-row {
        grid-template-columns: 1fr;
        gap: 15px;
    }
}
</style>
